import secureApi from "../services/secureApi";
export const addAdminApi = async (data) => {
  try {
    const response = await secureApi.post(
      "/admin/addAdmin",
      data
    );
    return response.data;
  } catch (error) {
    console.error("Add Admin Error:", error);
    throw error;
  }
};